module.exports = __webpack_public_path__ + "static/media/eye-icon.24e9e417.png";